<style scoped lang="less">
	// @import url("../../node_modules/swiper/css/swiper.css");
	#swipercom {
		width: auto;
		height: 20vh;
		margin: 1rem 0;
		padding-right: 2rem;

		img {
			width: 100%;
			height: 20vh;
		}

		slide {
			margin-left: 1rem;
		}

		#swiperIndex.swiper-container {
			width: 1rem;
			height: 2rem;
			border-radius: 0.1rem;



			.swiper-pagination-bullet-active {
				background-color: orangered;
			}

		}
	}

	.recommendPage .swiper-container {
		position: relative;
		width: 100%;
		height: 200px;
		background: pink;
	}

	.recommendPage .swiper-container .swiper-slide {
		width: 100%;
		line-height: 200px;
		background: yellowgreen;
		color: #000;
		font-size: 16px;
		text-align: center;
		margin-right: 1rem;
	}

	.swiper-slide {
		// margin-right: 1rem !important;
		border: 1px solid #ccc;
	}


	.swiperbox {
		position: relative;

		.delect {
			position: absolute;
			top: 0%;
			color: #f00d36;
			font-size: 1.5vw;
			right: 0%;
			display: block;
			background-color: #fff;
			border-radius: 10px 0 0 10px;
		}
	}
</style>


<template>
	<div id="swipercom">
		<!-- Swiper -->
		<swiper :options="swiperOption" ref="mySwiper" class="mySwiper">
			<swiperSlide v-for="(item,index) in imgslist" :key="index">
				<!-- <img :src="item" alt=""> -->
				<div class="swiperbox" @mouseover="deletepicmousover(index)" @mouseleave="deletepicmousleve()">
					<img :src="item.sx_tp_imgPath" alt="" srcset="">
					<span v-if="actives == index+1" @click="deletetrainpic(item.sx_tp_guid)"
						class="delect el-icon-close"></span>
				</div>
			</swiperSlide>
			
		</swiper>
	</div>
</template>
<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import {
		TrainDeleteTrainPic
	} from "@/request/api/trainroom/trainroom.js"

	export default {
		props: {
			swiperOptions: Object,
			imglist: Array,
			name: String
		},
		components: {
			swiper,
			swiperSlide,
		},
		data() {
			return {
				swiperOption: this.swiperOptions,
				imgslist: [],
				actives: 0
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			}
		},
		watch: {
			imglist(val) {
				if (val !== null) {
					this.imgslist = val
					console.log(val, "上传图片列表")
				}
			}
		},

		mounted() {
			this.imgslist = this.imglist

			// current swiper instance
			// 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
			console.log("获取到的", this.swiper);
			// this.swiper.slideTo(3, 1000, false);
		},
		methods: {
			// 鼠标移入移出事件
			deletepicmousover(idx) {
				this.actives = idx + 1
			},
			deletepicmousleve() {
				this.actives = 0
			},

			deletetrainpic(id) {
				this.$alert('确定要删除这张图片吗？', '删除图片', {
					confirmButtonText: '确定',
					callback: action => {
						TrainDeleteTrainPic(id).then(res => {
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你，' + res.data.msg,
									type: 'success'
								});
								this.$parent.gettainsinle()
							} else {
								this.$message(res.data.msg);
							}
						})
					}
				})

				
			}
		}

	};
</script>
